/* Gunrange shop — quick add (snippets/gr-quick-add-modal.liquid, layer
   "gr-quick-add").

   A product card's quick-add control is a link to the product with
   data-gr-open="gr-quick-add": GR.layer opens the modal on the same click,
   and this module fills it — the product's name in the heading at once, then
   the gr-quick-add section rendered against the product's URL
   (GR.fetchSection). Without JavaScript the link just opens the product page.

   If the content can't be loaded the modal says so and links to the product
   page. Closing the modal aborts a request still in flight. */
(() => {
  'use strict';

  const GR = window.GR;
  const modal = document.getElementById('gr-quick-add');
  if (!modal) return;
  if (!GR || typeof GR.fetchSection !== 'function') {
    console.error('[gr-quick-add] gr-shop.js has not loaded; quick add links go to the product page.');
    return;
  }

  const body = modal.querySelector('[data-gr-quick-add-body]');
  const title = modal.querySelector('[data-gr-quick-add-title]');
  const loadingTemplate = modal.querySelector('template[data-gr-quick-add-loading]');
  const errorTemplate = modal.querySelector('template[data-gr-quick-add-error]');
  if (!body || !title || !loadingTemplate || !errorTemplate) {
    console.error('[gr-quick-add] The modal markup is incomplete; quick add is off.');
    return;
  }

  let controller = null;

  const showError = (url) => {
    const fragment = errorTemplate.content.cloneNode(true);
    const link = fragment.querySelector('[data-gr-quick-add-link]');
    if (link) link.href = url;
    body.replaceChildren(fragment);
  };

  const load = async (url, name) => {
    if (controller) controller.abort();
    controller = new AbortController();
    const { signal } = controller;
    title.textContent = name || '';
    body.replaceChildren(loadingTemplate.content.cloneNode(true));
    body.setAttribute('aria-busy', 'true');
    try {
      const doc = await GR.fetchSection(url, 'gr-quick-add', { signal });
      if (signal.aborted) return;
      const content = doc.querySelector('[data-gr-quick-add-content]');
      if (!content) throw new Error(`The quick-add section rendered no content for ${url}.`);
      body.replaceChildren(document.importNode(content, true));
      modal.dispatchEvent(new CustomEvent('gr:quick-add-loaded', { bubbles: true, detail: { url } }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('[gr-quick-add] The product could not be loaded.', error);
      showError(url);
    } finally {
      if (!signal.aborted) body.removeAttribute('aria-busy');
    }
  };

  // GR.layer (gr-shop.js, loaded first) opens the modal on this same click.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-gr-quick-add]');
    if (!trigger || GR.layer.current !== modal) return;
    load(trigger.href, trigger.dataset.grQuickAddTitle);
  });

  modal.addEventListener('gr:layer-close', () => {
    if (controller) controller.abort();
  });
})();
